import React from 'react'
import ProgessBar from '../common/ProgressBar';
import { AiOutlineCloudUpload } from 'react-icons/ai';

const DocumentSelector = ({ handleSubmit, handleClear, fileInputRef, setSelectedFiles, currentProgress, selectedFile }) => {

    return (
        <div className='container mx-auto shadow-lg p-2 border rounded-md'>
            <form onSubmit={handleSubmit}>
                <div className="border-4 border-dashed rounded-md h-[150px] cursor-pointer flex items-center justify-center">
                    <label htmlFor="dropzone" className='cursor-pointer '>
                        <div className='flex flex-col items-center justify-center'>
                            <span className='text-5xl'>
                                <AiOutlineCloudUpload />
                            </span>
                            <p className="text-lg md:text-2xl">Click to Upload</p>
                            <p class="text-xs md:text-base text-gray-500 dark:text-gray-400">Images & Videos (MAX SIZE. 100mb)</p>
                        </div>
                        <input
                            type="file"
                            id='dropzone'
                            className='hidden'
                            ref={fileInputRef}
                            onChange={e => {
                                console.log(e.target.files[0]);
                                setSelectedFiles(e.target.files[0])
                            }}
                        />
                    </label>
                </div>
                <div className="my-2">
                    <button
                        disabled={!selectedFile}
                        type="submit"
                        className='rounded-md bg-blue-500 text-white py-3 text-center w-full'
                    >
                        Upload
                    </button>
                </div>
            </form>
            {
                selectedFile && <div className="my-2">
                    <button onClick={handleClear} className='rounded-md bg-red-500 text-white py-3 text-center w-full'>
                        Clear
                    </button>
                </div>
            }
            <div className="w-full my-5">
                {currentProgress > 0 && <ProgessBar percentage={currentProgress} />}
            </div>
        </div >
    )
}

export default DocumentSelector